import { META_VALUES } from '~constants/metaValues';
import { STEP_SUBMITTED_META } from '~constants/steps';
import { mapIncumbentValue } from '~redux/Simulation/mappers';
import { addPrefix } from '~utils/string';

export const mapAllDataScraperValues = incumbent => [
  ...mapIncumbentValue(addPrefix(incumbent, META_VALUES.UC_SUBMITTED_META), 'completed'),
  ...mapIncumbentValue(STEP_SUBMITTED_META, addPrefix(incumbent, '_unique_credential_information'))
];
